 <div class="main-side-nav">
  <mat-toolbar class="dashboard-logo">
    <img src="assets/images/dashboard-logo.svg"  alt="">
    <!-- <img src="assets/images/legance-white.svg" alt="logo"> -->
  </mat-toolbar>
  <ul class="side-nav" (mouseenter)="mouseHover()" (mouseleave)="mouseOut()">
    <ng-container *ngFor="let nav of navList">
      <li (click)="sideMenuName(nav.caption)">
        <div mat-list-item >
          <a routerLink="{{nav.routLink}}" class="link-menu" routerLinkActive="active-link">
              <img [src]="nav.listIcon" class="list-icon" alt="">
              <img [src]="nav.listIconHover" class="list-icon-hover" alt="">
            <span class="nav-caption">{{nav.caption | translate}}</span>
          </a>
        </div>
      </li>
    </ng-container>
  </ul>
</div>


